if (!customElements.get('product-sticky-bar')) {
  customElements.define(
    'product-sticky-bar',
    class ProductStickyBar extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.mobileMql = window.matchMedia('(max-width: 749px)');
        this.variantChangeUnsubscriber = undefined;
        this.onMediaChangeHandler = this.onMediaChange.bind(this);
        this.onScrollHandler = this.onScroll.bind(this);
        this.ticking = false;
      }

      connectedCallback() {
        this.submitButton = this.querySelector('.product-sticky-bar__submit');
        this.priceContainer = this.querySelector('.product-sticky-bar__price');
        this.mainSubmitButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.mainPrice = document.getElementById(`price-${this.sectionId}`);
        this.scrollTrigger = document.getElementById(`ProductStickyTrigger-${this.sectionId}`);

        if (!this.mainSubmitButton || !this.submitButton || !this.scrollTrigger) return;

        this.submitButton.addEventListener('click', this.onStickyClick.bind(this));
        this.mobileMql.addEventListener('change', this.onMediaChangeHandler);
        window.addEventListener('scroll', this.onScrollHandler, { passive: true });
        window.addEventListener('resize', this.onScrollHandler, { passive: true });
        window.addEventListener('load', this.onScrollHandler, { passive: true });

        if (typeof subscribe === 'function') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.sectionId) return;
            this.syncFromMain();
            this.onScrollHandler();
          });
        }

        this.syncFromMain();
        this.setBarVisible(false);
        requestAnimationFrame(() => this.updateVisibility());
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
        this.mobileMql.removeEventListener('change', this.onMediaChangeHandler);
        window.removeEventListener('scroll', this.onScrollHandler);
        window.removeEventListener('resize', this.onScrollHandler);
        window.removeEventListener('load', this.onScrollHandler);
        this.setBarVisible(false);
      }

      onMediaChange() {
        if (!this.mobileMql.matches) this.setBarVisible(false);
        else this.updateVisibility();
      }

      onScroll() {
        if (!this.ticking) {
          this.ticking = true;
          requestAnimationFrame(() => {
            this.updateVisibility();
            this.ticking = false;
          });
        }
      }

      updateVisibility() {
        if (!this.mobileMql.matches || !this.scrollTrigger || !this.mainSubmitButton) {
          this.setBarVisible(false);
          return;
        }

        const triggerRect = this.scrollTrigger.getBoundingClientRect();
        const mainRect = this.mainSubmitButton.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const triggerActivationLine = viewportHeight * 0.1;

        const hasPassedTrigger = triggerRect.top <= triggerActivationLine;
        const hasPassedMainButton = mainRect.bottom < 0;
        const mainVisibleInViewport = mainRect.bottom > 0 && mainRect.top < viewportHeight;

        const shouldShow = hasPassedTrigger && hasPassedMainButton && !mainVisibleInViewport;

        this.setBarVisible(shouldShow);
      }

      onStickyClick() {
        if (!this.mainSubmitButton || this.mainSubmitButton.disabled) return;
        this.mainSubmitButton.click();
        this.syncLoadingState();
      }

      syncLoadingState() {
        if (!this.mainSubmitButton || !this.submitButton) return;

        const sync = () => {
          const isLoading = this.mainSubmitButton.classList.contains('loading');
          this.submitButton.classList.toggle('loading', isLoading);
          this.submitButton.toggleAttribute('aria-disabled', this.mainSubmitButton.getAttribute('aria-disabled') === 'true');
          this.submitButton.querySelector('.loading__spinner')?.classList.toggle(
            'hidden',
            !isLoading
          );
        };

        sync();
        const interval = window.setInterval(() => {
          sync();
          if (!this.mainSubmitButton.classList.contains('loading')) {
            window.clearInterval(interval);
            this.syncFromMain();
          }
        }, 50);
      }

      syncFromMain() {
        if (this.mainPrice && this.priceContainer) {
          this.priceContainer.innerHTML = this.mainPrice.innerHTML;
        }

        if (!this.mainSubmitButton || !this.submitButton) return;

        const mainText = this.mainSubmitButton.querySelector('span');
        const stickyText = this.submitButton.querySelector('span');

        if (mainText && stickyText) stickyText.textContent = mainText.textContent;

        if (this.mainSubmitButton.disabled) {
          this.submitButton.setAttribute('disabled', 'disabled');
        } else {
          this.submitButton.removeAttribute('disabled');
        }

        const ariaDisabled = this.mainSubmitButton.getAttribute('aria-disabled');
        if (ariaDisabled === 'true') {
          this.submitButton.setAttribute('aria-disabled', 'true');
        } else {
          this.submitButton.removeAttribute('aria-disabled');
        }
      }

      setBarVisible(visible) {
        this.classList.toggle('is-visible', visible);
        document.body.classList.toggle('product-sticky-bar-active', visible);
      }
    }
  );
}
